import PortOpeningRuleOnPrem from './PortOpeningRuleOnPrem';
import WorkflowInstance from '../OnPremWorkflowInstance';
import User from '../User';
import { WorkflowState } from '../enums/WorkflowState';
import { authenticatedUser } from '../../authentication/authModule';
import { UserRole } from '../enums/UserRole';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import PORSiteToSiteConfiguration from './PORSiteToSiteConfiguration';
import PORSiteToSiteStandardConfiguration from './PORSiteToSiteStandardConfiguration';

export default class PortOpeningRequestSiteToSiteOnPrem {
	id!: number;

	type!: PortOpeningRequestsDirection;

	companyName!: string;

	trackerID!: number;

	//workID!: number;

	approver!: User;

	exxonConfiguration!: PORSiteToSiteConfiguration;

	externalConfiguration!: PORSiteToSiteConfiguration;

	standardConfiguration!: PORSiteToSiteStandardConfiguration;

	exxonEncrypDomain!: string;

	externalEncrypDomain!: string;

	conDeviceCount!: string;

	workflowInstance!: WorkflowInstance;

	changeTicketId?: string;

	selectedOption!: number;


	constructor(obj: any) {
		this.id = obj.id;
		this.type = obj.type;
		this.companyName = obj.companyName;
		this.trackerID = obj.trackerID;
		this.approver = obj.approver
		this.workflowInstance = new WorkflowInstance(obj.onPremWorkflowInstance);
		this.type = new PortOpeningRequestsDirection().fromName(obj.direction?.name);
		this.exxonConfiguration = new PORSiteToSiteConfiguration(obj.xomTunnelInfo);
		this.externalConfiguration = new PORSiteToSiteConfiguration(obj.extTunnelInfo);
		this.standardConfiguration = new PORSiteToSiteStandardConfiguration(obj.xomStandardConfiguration)
		this.exxonEncrypDomain = obj.xomEncrypDomain;
		this.externalEncrypDomain = obj.extEncrypDomain;
		this.conDeviceCount = obj.conDeviceCount;
		this.selectedOption = obj.selectedOption;
		this.changeTicketId = obj.changeTicketId;
	}

	isEditable(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
		return (
			authenticatedUser.userId === this.workflowInstance.createdBy.id &&
			[
				WorkflowState.Draft.value,
				WorkflowState.Review.value,
			].includes(currentState)
		);
	}

	canHaveApproval(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
		return (
			(currentState === WorkflowState.PendingForPolicyTeamApproval.value &&
				authenticatedUser.isInRole(UserRole.PORToOnPremTechReviewer)
			) ||
			(currentState === WorkflowState.PendingAccountOwnerApproval.value &&
				authenticatedUser.userId === this.approver?.id
			)
		);
	}

	canHaveReview(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
		return (
			currentState === WorkflowState.PendingForPolicyTeamApproval.value &&
			authenticatedUser.isInRole(UserRole.PORToOnPremTechReviewer)
		);
	}

	canHaveRejection(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
		return (
			(currentState === WorkflowState.PendingForPolicyTeamApproval.value &&
				authenticatedUser.isInRole(UserRole.PORToOnPremTechReviewer)
			) ||
			(currentState === WorkflowState.PendingAccountOwnerApproval.value &&
				authenticatedUser.userId === this.approver?.id
			)
		);
	}

 	canHaveCancellation(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
		return (
			authenticatedUser.userId === this.workflowInstance.createdBy.id &&
        	currentState === WorkflowState.Review.value
		);
	}

	canHaveCompletion(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.onPremWorkflowState.value;
		return (
			currentState === WorkflowState.AwaitingImplementation.value &&
			authenticatedUser.isInRole(UserRole.POROnPremS2SVPNImplementor)
		);
	}
}